import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-dropdown-button-open': {
    'ar-AE': 'فتح القائمة المنسدلة',
    'bn-IN': 'ড্রপডাউন খুলুন',
    'cs-CZ': 'otevřít rozevírací seznam',
    'da-DK': 'Åbn dropdown',
    'de-DE': 'Dropdown öffnen',
    'en-IN': 'open drop-down',
    'en-US': 'open dropdown',
    'es-CL': 'abrir menú desplegable',
    'es-CO': 'abrir menú desplegable',
    'es-ES': 'abrir menú desplegable',
    'es-MX': 'abrir menú desplegable',
    'es-US': 'abrir menú desplegable',
    'fr-BE': 'ouvrir le menu déroulant',
    'fr-CA': 'ouvrir la liste déroulante',
    'fr-FR': 'ouvrir la liste déroulante',
    'he-IL': 'פתיחת התפריט הנפתח',
    'hi-IN': 'ड्रॉपडाउन खोलें',
    'it-IT': 'apri il menu a tendina',
    'ja-JP': 'ドロップダウンを開く',
    'kn-IN': 'ಡ್ರಾಪ್‍‌ಡೌನ್ ತೆರೆಯಿರಿ',
    'ko-KR': '드롭다운 열기',
    'ml-IN': 'ഡ്രോപ്പ്ഡൗൺ തുറക്കുക',
    'mr-IN': 'ड्रॉपडाउन उघडा',
    'nl-BE': 'vervolgkeuzelijst openen',
    'nl-NL': 'vervolgkeuzelijst openen',
    'pl-PL': 'otwórz listę rozwijaną',
    'pt-BR': 'abrir menu suspenso',
    'pt-PT': 'abrir menu suspenso',
    'sv-SE': 'öppna rullgardinsmenyn',
    'ta-IN': 'கீழ்த்தோன்றல் மெனுவைத் திற',
    'te-IN': 'డ్రాప్‌డౌన్‌ను తెరవండి',
    'tr-TR': 'Açılır menüyü aç',
    'zh-CN': '打开下拉列表',
    'zh-TW': '打開下拉式選單',
  },
  'kat-dropdown-button-close': {
    'ar-AE': 'إغلاق القائمة المنسدلة',
    'bn-IN': 'ড্রপডাউন বন্ধ করুন',
    'cs-CZ': 'zavřít rozevírací seznam',
    'da-DK': 'Luk dropdown',
    'de-DE': 'Dropdown schließen',
    'en-US': 'close dropdown',
    'es-CL': 'cerrar menú desplegable',
    'es-CO': 'cerrar menú desplegable',
    'es-ES': 'cerrar menú desplegable',
    'es-MX': 'cerrar menú desplegable',
    'es-US': 'cerrar menú desplegable',
    'fr-BE': 'fermer le menu déroulante',
    'fr-CA': 'fermer la liste déroulante',
    'fr-FR': 'fermer la liste déroulante',
    'he-IL': 'סגירת התפריט הנפתח',
    'hi-IN': 'ड्रॉपडाउन बंद करें',
    'it-IT': 'chiudi il menu a tendina',
    'ja-JP': 'ドロップダウンを閉じる',
    'kn-IN': 'ಡ್ರಾಪ್‍‌ಡೌನ್ ಮುಚ್ಚಿರಿ',
    'ko-KR': '드롭다운 닫기',
    'ml-IN': 'ഡ്രോപ്പ്ഡൗൺ അടയ്ക്കുക',
    'mr-IN': 'ड्रॉपडाउन बंद करा',
    'nl-BE': 'vervolgkeuzelijst sluiten',
    'nl-NL': 'vervolgkeuzelijst sluiten',
    'pl-PL': 'zamknij listę rozwijaną',
    'pt-BR': 'fechar menu suspenso',
    'pt-PT': 'fechar menu suspenso',
    'sv-SE': 'stäng rullgardinsmenyn',
    'ta-IN': 'கீழ்த்தோன்றல் மெனுவை மூடுக',
    'te-IN': 'డ్రాప్‌డౌన్‌ను మూసివేయండి',
    'tr-TR': 'Açılır menüyü kapat',
    'zh-CN': '关闭下拉列表',
    'zh-TW': '關閉下拉式選單',
  },
};

export default katTranslator(strings);
